import React from 'react';
import Section from '../../components/layout/Section';
import styled from 'styled-components';
import { BG, FONT, MAIN_BLUE } from '../../styles/color';

const BackgroundImg = styled.img`
  height: 100%;
  width: 100%;
`;

const Shadow = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;

  background-color: ${ BG.deep01 };
  opacity: 0.25;
`;

const Content = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
`;

const MainTitle = styled.div`
  display: inline;
  font: normal 900 128px Pretendard Variable;
  color: ${ MAIN_BLUE.mid };
`;

const SubTitle = styled.div`
  display: inline;
  font: normal 900 48px Pretendard Variable;
  color: ${ MAIN_BLUE.light };
`;

export default function MainSection() {
  return (
    <Section type={1}>
        <BackgroundImg src="https://www.ywcnp.com/static/media/company.4ab6d76ebbcb73b2fe80.jpg"/>
        <Shadow></Shadow>
        <Content>
            <MainTitle>Youngwon</MainTitle>
            <SubTitle>안녕하세요, 영원씨앤피입니다.</SubTitle>
        </Content>
    </Section>
  )
};
  // 이미지는 임시